import { AfterViewInit, ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ClientsService } from '../../../../../services/client-service/clients.service';
import { LotService } from '../../../../../services/lot-service/lot.service';
import { SampleAnalyseResponseDto, SampleService } from '../../../../../services/sample-service/sample.service';
import { TerrrainService } from '../../../../../services/terrains-service/terrrain.service';
import { UserService } from '../../../../../services/user-service/user.service';
import { LotDto } from '../../../../_models/LotDto';
import { forkJoin, interval, takeWhile } from 'rxjs';
import {finalize, tap} from "rxjs";
import { ShortClientDto } from '../../../../_models/client.dtos';
import { SampleStatus, PrelevementSampleDto, PrelevementSampleView } from '../../../../_models/sampleDTO';
import { TerrainDTO } from '../../../../_models/terrain.dto';
import { typeSampleDTO, ProductData } from '../../../../_models/typeSampleDTO';
import { AppUserDTO } from '../../../../_models/userDTO';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, NgIf } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import { MatDatepickerToggle, MatDatepicker, MatDatepickerInput } from '@angular/material/datepicker';
import { MatExpansionModule, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { AnalyseService } from '../../../../../services/analyse-service/analyse.service';
import { HandleErrorsService } from '../../../../../services/handle-erros/handle.errors.service';
import { MatriceService } from '../../../../../services/matrice-service/matrice.service';
import { ParametreService } from '../../../../../services/parametre-service/parametre.service';
import { SampleStatusService } from '../../../../../services/sample-status-service/sample.status.service';
import { TypeAnalyseService } from '../../../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../../../_modal/dialog.service';
import { ApiService } from '../../../../_services/api.service';
import { Endpoints } from '../../../../endpoints';
import { CustomizerSettingsService } from '../../../../../customizer-settings/customizer-settings.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../../environments/environment';
import { ParameterDTO } from '../../../../_models/ParameterDTO';
import { ShortMatriceDto } from '../../../../_models/matrice.dtos';
import { ShortTypeAnalyseDto } from '../../../../_models/type.analyse.dtos';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  standalone:true,
  selector: 'app-prelevement',
  templateUrl: './prelevement.component.html',
  providers: [TerrrainService,AnalyseService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, MatriceService, SampleService, HandleErrorsService, ClientsService, SampleStatusService,ApiService, Endpoints],
  imports: [MatExpansionModule,
      MatNativeDateModule,
      CommonModule,FormsModule,
MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
      MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
      MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,
      MatSuffix, MatSortModule, MatInputModule, MatOption,MatIconModule, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription
  ],
  styleUrls: ['./prelevement.component.scss']
})
export class PrelevementComponent implements OnInit, OnChanges, AfterViewInit  {

  form: FormGroup;
  showForm: boolean = false;
  samples: any[] = [];
  departments: any[] = [];
  searchVal: string = ''
  loadingTable: boolean = true;

  sampleTypeControl = new FormControl<string>('');
  dataSource: MatTableDataSource<SampleAnalyseResponseDto> = new MatTableDataSource<SampleAnalyseResponseDto>();
  dataSource1: MatTableDataSource<PrelevementSampleDto> = new MatTableDataSource<PrelevementSampleDto>();

  @ViewChild('receptionModal') receptionModal!: TemplateRef<any>;
  @ViewChild('content') content!: TemplateRef<any>;

  receptionForm!: FormGroup;
  selectedSample!: any;

  clientList: ShortClientDto[] = [];
  typeStList: typeSampleDTO[] = [];
  terrainList: TerrainDTO[] = [];
  filteredTerrains: TerrainDTO[] = [];
  lotList: LotDto[] = [];
  preleveurs: AppUserDTO[] = [];
  productList: ProductData[] = [];
  filteredProducts: ProductData[] = [];
  sampleTypes: string[] = [];
  selectedSampleType!: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('editModal') editModal: TemplateRef<any>;
  @ViewChild('viewModal') viewModal: TemplateRef<any>;
  selectedClientId: number | null = null;
  selectedLotId: number | null = null;
  selectedClientName: string;
  selectedLotName: string;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
        this.initializeForm();
    }
}

ngOnInit(): void {
  this.loadPrelevements();
  this.fetchClientList();
  this.fetchLotList();
  this.loadPreleveurs();
  this.loadProducts();
  this.initializeForm();
  this.loadDepartments();
  this.loadAllTypeAnalyses();
  this.form.get('typeSampleName')?.valueChanges.subscribe(type => {
    this.filterMatricesByType(type);
  });
  /* ===========================
     🔹 LOT → CLIENT → TERRAINS
     =========================== */
  this.form.get('batchId')?.valueChanges.subscribe((batchId: number) => {

    this.selectedLotId = batchId;
    this.terrainList = [];

    if (!batchId) {
      this.form.patchValue({ clientId: null, terrainId: null });
      return;
    }

    const selectedLot = this.lotList.find(l => l.id === batchId);
    if (!selectedLot) return;

    const clientId = selectedLot.clientId;

    // ✅ set client automatically
    this.form.patchValue(
      { clientId: clientId, terrainId: null },
      { emitEvent: false }
    );

    // (اختياري) منع تغيير client إذا جا من lot
    this.form.get('clientId')?.disable({ emitEvent: false });

    // ✅ fetch terrains of this client only
    this.fetchTerrainList(clientId);
  });

  /* ===========================
     🔹 CHANGEMENT MANUEL CLIENT
     (cas sans lot)
     =========================== */
  this.form.get('clientId')?.valueChanges.subscribe(clientId => {

    if (this.form.get('batchId')?.value) return; // 🚫 lot هو المتحكم

    this.terrainList = [];
    this.form.patchValue({ terrainId: null }, { emitEvent: false });

    if (clientId) {
      this.fetchTerrainList(clientId);
    }
  });

  /* ===========================
     🔹 ouverture depuis session
     =========================== */
  const batchIdFromSession = sessionStorage.getItem('lastCreatedBatchId');

  if (batchIdFromSession) {
    const batchId = Number(batchIdFromSession);

    const intervalId = setInterval(() => {
      if (this.lotList.length && this.clientList.length) {
        this.handleOpenSampleFromBatch(batchId);
        sessionStorage.removeItem('lastCreatedBatchId');
        sessionStorage.removeItem('openSampleAfterUpdate');
        clearInterval(intervalId);
      }
    }, 200);
  }

  this.sampleService.fetchSampleTypes().subscribe(types => {
    this.sampleTypes = types;
  });
}

private handleOpenSampleFromBatch(batchId: number): void {

  if (this.modalOpened) return;

  const selectedLot = this.lotList.find(lot => lot.id === batchId);
  if (!selectedLot) return;

  this.form.patchValue({
    batchId: selectedLot.id,
    clientId: selectedLot.clientId,
    terrainId: null
  }, { emitEvent: false });

  this.form.get('batchId')?.disable({ emitEvent: false });
  this.form.get('clientId')?.disable({ emitEvent: false });

  this.selectedLotId = selectedLot.id;
  this.selectedLotName = selectedLot.batchName;
  this.selectedClientId = selectedLot.clientId;

  this.fetchTerrainList(this.selectedClientId);

  this.modalOpened = true;
  this.openModal(this.content);
}

  showRemarques = false;
  availableMethodes: any[] = [];
compareById = (a: any, b: any): boolean => {
  return a != null && b != null && a === b;
};

filterMatricesByType(typeSampleName: string) {
  console.log('--- Début filtrage des matrices ---');
  console.log('Liste complète des matrices:', this.matriceList);

  this.filteredMatrices = this.matriceList.filter(
    m => {
      const match = m.type.toLowerCase() === typeSampleName.toLowerCase();
      console.log(`Matrice: ${m.nom} | type: ${m.type} | match: ${match}`);
      return match;
    }
  );

  console.log('Matrices filtrées:', this.filteredMatrices);

  // réinitialiser la sélection matrice si le type change
  this.form.get('matriceId')?.setValue(null);
  console.log('Sélection matrice réinitialisée.');
  console.log('Valeur actuelle du formulaire:', this.form.value);
  console.log('-----------------------------------');
}
onConditionnementChange(value: string) {
  this.showRemarques = (value === 'Non conforme');

  // Optionnel : si conforme, effacer les remarques
  if (!this.showRemarques) {
    this.receptionForm.get('remarques')?.setValue('');
  }
}
  // 🔹 Méthode pour récupérer la liste des départements
  loadDepartments() {
    this.sampleService.fetchDepartementList().subscribe({
      next: (res: any[]) => {
        this.departments = res;
        console.log('Liste des départements:', this.departments);
      },
      error: (err) => {
        console.error('Erreur lors du chargement des départements:', err);
      }
    });
  }
initReceptionForm() {
  const now = new Date();

  console.log("🕒 Date JS actuelle :", now);

  // Convertir en YYYY-MM-DDTHH:mm local
  const pad = (n: number) => n.toString().padStart(2, '0');
  const formattedNow = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;

  console.log("🕒 Date formatée pour datetime-local :", formattedNow);

  this.receptionForm = this.fb.group({
    id: [null, Validators.required],
    dateReception: [formattedNow, Validators.required], // <-- date locale maintenant
    temperatureReception: [''],
    conditionnementReception: [''],
    propreteContamination: [''],
    volumeSuffisant: [''],
    etiquetageLisible: [''],
    scelleIntact: [''],
    sampleCondition: [''],
    storageConditions: [''],
    remarques: [''],
    methodeId: [null],
    volume: ['0']
  });

  console.log("📋 FormGroup créé :", this.receptionForm);

  // Vérifier la valeur du formControl
  console.log("📅 dateReception FormControl :", this.receptionForm.get('dateReception')?.value);
}


  prelevementSamples: any[] = [];
selectedUnit = '';
displayValue = '';
displayVolume: string = '';
selectedVolumeUnit: string = ''; // default

onValueChange(event: Event) {
  const input = event.target as HTMLInputElement;

  // نأخذ فقط الرقم (بدون الوحدة)
  const numeric = input.value.replace(/[^\d.]/g, '');
  this.displayValue = numeric;

  this.updateCombined();
}

onVolumeChange(event: any) {
  const inputValue = event.target.value;

  // استخراج الرقم فقط بدون الوحدة
  this.displayVolume = inputValue.replace(/[^\d.]/g, '');

  this.updateVolumeCombined();
}

updateCombined() {
  const combined = this.displayValue
    ? `${this.displayValue} ${this.selectedUnit}`
    : '';

  this.form.patchValue({ qtePre: combined }, { emitEvent: false });
}
updateVolumeCombined() {
  const combined = this.displayVolume
    ? `${this.displayVolume} ${this.selectedVolumeUnit}`
    : '';

  this.form.patchValue({ qtePre: combined }, { emitEvent: false });
}

loadPrelevementSamples() {
  this.sampleService.getSamplesByStatus(SampleStatus.PRELEVEMENT).subscribe({
    next: (samples) => {
      this.prelevementSamples = samples; // variable utilisée dans le mat-select
      console.log('Samples PRELEVEMENT:', samples);
    },
    error: (err) => console.error('Erreur chargement PRELEVEMENT:', err)
  });
}
    trackByFn(index: number, item: any): any {
      return item.id; // ou item.codeParameter selon ce que tu veux comme identifiant unique
    }
    submitReception(accept: boolean) {
      if (!this.selectedSample?.sampleId) {
        console.error("❌ selectedSample.id manquant, impossible de valider", this.selectedSample);
        return;
      }

      if (this.receptionForm.invalid) {
        console.warn("⚠️ Formulaire invalide :", this.receptionForm.value);
        return;
      }
console.log('📦 volume calculé:', this.displayVolume, this.selectedVolumeUnit);
      const dto = {
        id: this.selectedSample.sampleAnalyseId,
        accept: accept,  // <-- utilise le paramètre ici
        dateReception: this.receptionForm.value.dateReception ?? null,
        temperatureReception: this.receptionForm.value.temperatureReception ?? '',
        conditionnementReception: this.receptionForm.value.conditionnementReception ?? '',
        propreteContamination: this.receptionForm.value.propreteContamination ?? '',
        volumeSuffisant: this.receptionForm.value.volumeSuffisant ?? '',
        etiquetageLisible: this.receptionForm.value.etiquetageLisible ?? '',
        scelleIntact: this.receptionForm.value.scelleIntact ?? '',
        remarques: this.receptionForm.value.remarques?.trim() || '',
        methodeId: this.receptionForm.value.methodeId ?? null,
        typeAnalyseIds: [this.selectedSample.typeAnalyseId],
        volume: this.displayVolume && this.displayVolume !== ''
                ? `${this.displayVolume} ${this.selectedVolumeUnit}`
                : '0'
            };

      console.log("📨 DTO à envoyer au backend :", dto);

      this.sampleService.validateSample(dto).subscribe({
        next: (response) => {
          console.log("✅ Réponse du backend :", response);
          this.modalService.dismissAll();
          this.cdr.detectChanges();
          this.dialogService.openSuceessAlert(`Échantillon ${accept ? 'validé' : 'rejeté'} avec succès`);
          this.loadPrelevements();
        },
        error: (err) => {
          console.error("❌ Erreur lors de la validation :", err);
          this.dialogService.openDangerAlert('Erreur lors de la validation de l’échantillon');
        }
      });
    }


  paramList: ParameterDTO[] = []
  matriceList: ShortMatriceDto[] = []
  typeAnalyseList: ShortTypeAnalyseDto[] = []
filteredMatrices: ShortMatriceDto[] = [];
// 🔹 Charger toutes les matrices à l'ouverture du modal
fetchAllMatrices() {
  this.matriceService.fetchMatriceList().subscribe({
    next: response => {
      if (response.status) {
        this.matriceList = response.data;
        console.log("Toutes les matrices :", this.matriceList);
      }
    },
    error: err => this.handleErrors.catchError(err)
  });
}
// 🔹 Quand l'utilisateur choisit une matrice

// Appel au service pour récupérer tous les types d'analyse
// TrackBy pour Angular
trackById(index: number, item: any) {
  return item.id;
}

// Charger toutes les analyses
loadAllTypeAnalyses() {
  console.log("🔹 Appel à loadAllTypeAnalyses()");

  this.typeAnalyseService.getAllTypeAnalyses().subscribe({
    next: (response: any[]) => {
      console.log("✅ Réponse API reçue :", response);

      if (!response) {
        console.error("❌ Réponse API null ou undefined !");
        return;
      }

      if (!Array.isArray(response)) {
        console.error("❌ Réponse API n'est pas un tableau !", response);
        return;
      }

      console.log("📦 Nombre de TypeAnalyse reçus :", response.length);
      response.forEach((ta, index) => {
        console.log(`TypeAnalyse ${index} : id=${ta.id}, codeAT=${ta.codeAT}, name=${ta.name}`);
      });

      // Assignation à la variable du composant
      this.typeAnalyseList = response;
      console.log("📝 typeAnalyseList après assignation :", this.typeAnalyseList);

      // Vérifier si le FormControl existe
      if (this.form && this.form.get('typeAnalyseId')) {
        console.log("🔹 FormControl 'typeAnalyseId' avant setValue :", this.form.get('typeAnalyseId')?.value);
        this.form.get('typeAnalyseId')?.setValue([]);
        console.log("🔹 FormControl 'typeAnalyseId' après setValue :", this.form.get('typeAnalyseId')?.value);
      } else {
        console.warn("⚠️ FormControl 'typeAnalyseId' non trouvé !");
      }

      // Forcer Angular à détecter les changements
      this.cdr.detectChanges();
      console.log("🔹 Changement détecté par cdr.detectChanges()");
    },
    error: err => {
      console.error("❌ Erreur API :", err);
      this.handleErrors.catchError(err);
    },
    complete: () => {
      console.log("🔹 loadAllTypeAnalyses() terminé ✅");
    }
  });
}
// 🔹 Quand le mat-select s'ouvre ou se ferme
onTypeAnalyseOpened(opened: boolean) {
  console.log('🔹 mat-select ouvert ?', opened);
  console.log('Current typeAnalyseList:', this.typeAnalyseList);
  console.log('FormControl value:', this.form.get('typeAnalyseId')?.value);
}

// 🔹 Quand une sélection change
onTypeAnalyseSelectionChange(event: any) {
  console.log('🔹 Sélection modifiée:', event.value);
  console.log('FormControl après changement:', this.form.get('typeAnalyseId')?.value);
}


// Quand l'utilisateur change la sélection
onTypeAnalyseChange(typeAnalyseIds: number[]) {
  console.log("Types d'analyse sélectionnés :", typeAnalyseIds);

  if (typeAnalyseIds && typeAnalyseIds.length > 0) {
    typeAnalyseIds.forEach(id => this.fetchParametres(id));
  }
}


onTypeAnalyseChange1(typeAnalyseId: number) {
  const matriceId = this.form.value.matriceId;
  console.log("TypeAnalyse sélectionné :", typeAnalyseId, "pour matrice :", matriceId);
  if (matriceId && typeAnalyseId) {
    this.fetchParametres(typeAnalyseId);
  }
}


/*🔹 Charger les types d'analyse selon la matrice sélectionnée
fetchTypeAnalyseList(matriceId: number) {
  if (!matriceId) return;
  this.typeAnalyseService.fetchTypeAnalyseList(matriceId).subscribe({
    next: response => {
      if (response.status) {
        this.typeAnalyseList = response.data;
        console.log("typeAnalyseList :", this.typeAnalyseList);
      }
    },
    error: err => this.handleErrors.catchError(err)
  });
}*/

// 🔹 Charger les paramètres selon le type d'analyse choisi
fetchParametres(typeAnalyseId: number) {
  const taId = typeAnalyseId ?? this.receptionForm.value.typeAnalyseId;
  if (!taId) return;

  this.parametreService.fetchParametreList(taId).subscribe({
    next: response => {
      if (response.status) {
        this.paramList = response.data;
        console.log("paramList :", this.paramList);
      }
    },
    error: err => this.handleErrors.catchError(err)
  });
}

// 🔹 Ouvrir le modal
openReceptionModal(sample: any) {
  console.log("📥 Sample reçu pour réception :", sample);
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');
  const formattedNow = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;

  // 🔹 Vérifier que le sample a bien un id
  if (!sample?.sampleId) {
    console.error("❌ Sample invalide : id manquant", sample);
    return; // arrêter si id null
  }

  this.selectedSample = sample;
  this.initReceptionForm();
  // 🔹 Récupérer les méthodes depuis le backend si nécessaire
  if (sample?.typeAnalyseId) {
    this.typeAnalyseService.getTypeAnalyseById(sample.typeAnalyseId)
      .subscribe((typeAnalyse: any) => {
        this.availableMethodes = typeAnalyse.methodes || [];
        console.log("Méthodes disponibles :", this.availableMethodes);
      });
  } else {
    this.availableMethodes = [];
  }
  console.log("✅ selectedSample :", this.selectedSample);

  // 🔹 Initialiser le formulaire si nécessaire

  // 🔹 Reset et patch des valeurs existantes du sample
  this.receptionForm.reset({
    id: this.selectedSample.sampleId,  
    dateReception: sample.dateReception || formattedNow,
    temperatureReception: sample.temperatureReception ?? '',
    remarques: sample.remarques ?? '',
    methodeId: sample.methodeId ?? '', 
    volume: sample.volume ?? '',
    conditionnementReception: sample.conditionnementReception ?? '',
    propreteContamination: sample.propreteContamination ?? '',
    volumeSuffisant: sample.volumeSuffisant ?? '',
    etiquetageLisible: sample.etiquetageLisible ?? '',
    scelleIntact: sample.scelleIntact ?? '',
  });


  console.log("📄 Formulaire initialisé :", this.receptionForm.value);

  // 🔹 Reset des listes dépendantes
  this.typeAnalyseList = [];
  this.paramList = [];

  // 🔹 Charger toutes les matrices pour que l'utilisateur choisisse
  console.log("📌 Chargement de toutes les matrices");
  this.fetchAllMatrices();

  // 🔹 Ouvrir le modal
  console.log("📌 Ouverture du modal de réception");
  this.modalService.open(this.receptionModal, {
    size: 'lg',
    backdrop: true,
    keyboard: true
  });
}



initializeForm() {
  this.form = this.fb.group({
    id: [''],
    sampleCode: [''],       
    typeSampleName: ['', Validators.required],        // obligatoire pour la sélection
    clientId: [null, Validators.required],
    clientName: [''],

    batchReference: [''],
    terrainId: [null],
    terrainVarPlante: [''],
    collectedById: [null],
    collectedByUsername: [''],
    qtePre: ['', [Validators.required]],
    collectionDate: [new Date(), Validators.required],
    temperaturePrelevement: [''],
    dateProduction: [''],
    dateLimiteConsommation: [''],
    typeAnalyseId: [[], Validators.required],
    matriceId: [null, Validators.required],
    designation: [''], 
    scelle: [false], 
    accredited: [false], 
    preleveParClient: [false],              // Oui / Non
    conditionnement: [''],        // Pot / Flacon / Sachet
    priorite: [''], 
  });
  
}


  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private apiService: ApiService,
    private parametreService: ParametreService,
    private endpoints: Endpoints,
    private cdr: ChangeDetectorRef,
    private sampleService: SampleService,
    private lotService: LotService,
    private clientService: ClientsService,
    private terrainService: TerrrainService,
    private userService: UserService,
    private cookieService: CookieService,
    private dialogService: DialogService,
    public themeService: CustomizerSettingsService,

    private overlayContainer: OverlayContainer,
    private matriceService:MatriceService,
    private parameterService:ParametreService,
    private typeAnalyseService: TypeAnalyseService,
    private handleErrors: HandleErrorsService) {
  }
displayedColumns: string[] = [
    'sampleCode',             // Code
    'typeSampleName',         // Type échantillon
    'clientName',             // Client
    'batchReference', 
    'accredited',
    'preleveParClient',        
    'terrainVarPlante',       // Terrain
    'collectedByUsername',    // Prélevé par
    'qtePre',                 // Quantité
    'collectionDate',  
    'departementName',       
    'temperaturePrelevement', // Température prélèvement
    'dateProduction',         // Date production
    'dateLimiteConsommation', // DLC
    'matriceNom',             // Matrice
    'typeAnalyseCode',        // Type d'analyse
    'designation',            // Désignation
    'priorite',               // Priorité
    'scelle',                 // Scellé
    'conditionnement',        // Conditionnement
    'action'                  // Actions (bouton supprimer)
];
columnLabels: Record<string, string> = {
  sampleCode: 'Code échantillon',
  typeSampleName: 'Type échantillon',
  clientName: 'Client',
  batchReference: 'Lot',
  accredited: 'Accrédité',
  preleveParClient: 'Prélevé par client',
  terrainVarPlante: 'Terrain',
  collectedByUsername: 'Prélevé par',
  qtePre: 'Quantité prélevée',
  collectionDate: 'Date de collecte',
  departementName: 'Département',
  temperaturePrelevement: 'Température prélèvement',
  dateProduction: 'Date de production',
  dateLimiteConsommation: 'DLC',
  matriceNom: 'Matrice',
  typeAnalyseCode: 'Type d\'analyse',
  designation: 'Désignation',
  priorite: 'Priorité',
  scelle: 'Scellé',
  conditionnement: 'Conditionnement',
  action: 'Action',
};
  
  columns: string[] = [...this.displayedColumns];


  applyFilter(event: Event) {
    this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource1.filter = this.searchVal
}
onSelectionChange(column: string): void {
  if (this.displayedColumns.includes(column)) {
      this.displayedColumns = this.displayedColumns.filter(c => c !== column);
  } else {
      this.displayedColumns.push(column)
  }
  this.setColsCookie()
}  
loadPrelevements() {
  console.log('🔄 Chargement des SampleAnalyse (PRELEVEMENT) pour le département du user connecté');

  this.sampleService.getPrelevementsForConnectedUser()
    .subscribe({
      next: data => {
        console.log('✅ SampleAnalyse reçues :', data);

        if (!data || data.length === 0) {
          console.warn('⚠️ Aucune analyse à afficher');
          this.dataSource.data = [];
          return;
        }

        // Mapping complet pour la table
        const mappedData = data.map((sa, index) => {
          console.log(`➡️ Analyse #${index + 1}`, sa);

          return {
            sampleAnalyseId: sa.sampleAnalyseId,
            sampleId: sa.sampleId,
            sampleCode: sa.sampleCode,
            status: sa.status,

            typeAnalyseId: sa.typeAnalyseId,
            typeAnalyseName: sa.typeAnalyseName,

            departementId: sa.departementId,
            departementName: sa.departementName,

            clientId: sa.clientId ?? null,
            clientName: sa.clientName ?? '-',

            batchReference: sa.batchReference ?? '-',
            accredited: sa.accredited ?? false,
            preleveParClient: sa.preleveParClient ?? false,

            collectedById: sa.collectedById ?? null,
            collectedByUsername: sa.collectedByUsername ?? '-',

            qtePre: sa.qtePre ?? null,
            collectionDate: sa.collectionDate ?? null,
            temperaturePrelevement: sa.temperaturePrelevement ?? null,
            dateProduction: sa.dateProduction ?? null,
            dateLimiteConsommation: sa.dateLimiteConsommation ?? null,

            matriceId: sa.matriceId ?? null,
            matriceName: sa.matriceName ?? '-',
            terrainId: sa.terrainId ?? null,
            terrainVarPlante: sa.terrainVarPlante ?? '-',

            designation: sa.designation ?? '-',
            scelle: sa.scelle ?? false,
            conditionnement: sa.conditionnement ?? '-',
            priorite: sa.priorite ?? '-',
            typeSampleName: sa.typeSampleName ?? '-'
          };
        });

        console.log('📊 Données mappées pour la table :', mappedData);

        this.dataSource.data = mappedData;

        if (this.sort) this.dataSource.sort = this.sort;
        if (this.paginator) this.dataSource.paginator = this.paginator;

        console.log('🎉 Table PRELEVEMENT chargée avec succès');
      },
      error: err => {
        console.error('❌ Erreur chargement prélèvements :', err);
      }
    });
}

  // --- Clients ---
  fetchClientList() {
    this.clientService.loadClients().subscribe({
      next: res => {
        if (res.status) this.clientList = res.data;
      },
      error: err => console.error('❌ Erreur clients :', err)
    });
  }
  private modalOpened = false;

openModal(content: any) {

  this.typeAnalyseList = [];
  this.paramList = [];

  console.log("📌 Ouverture modal prélèvement");

  this.fetchAllMatrices();

  const modalRef = this.modalService.open(content, {
    ariaLabelledBy: 'modal-basic-title',
    size: 'xl',
    backdrop: true,
    keyboard: true
  });

  // 🔹 Charger les types d'analyse après ouverture
  modalRef.shown.subscribe(() => {
    console.log("🔹 Modal complètement ouvert !");
    this.loadAllTypeAnalyses();
  });
}


  // --- Lots ---
  fetchLotList() {
    this.lotService.getAllBatches().subscribe({
      next: res => this.lotList = res,
      error: err => console.error('❌ Erreur lots :', err)
    });
  }

fetchTerrainList(clientId: number): void {
  console.log('fetchTerrainList appelé avec clientId:', clientId);

  if (!clientId) {
    console.log('clientId vide, terrainList reset');
    this.terrainList = [];
    return;
  }

  this.terrainService.findByClientId(clientId).subscribe({
    next: (res) => {
      console.log('Réponse du service terrainService.findByClientId:', res);

      if (res?.status && res.data) {
        this.terrainList = res.data;
        console.log('terrainList mise à jour:', this.terrainList);
      } else {
        console.log('Aucun terrain trouvé pour ce client');
        this.terrainList = [];
      }
    },
    error: (err) => {
      console.error('Erreur fetchTerrainList:', err);
      this.terrainList = [];
    }
  });
}
  
  // --- Préleveurs ---
  loadPreleveurs() {
    this.userService.getUsers().subscribe({
      next: res => {
        if (res.status) {
          this.preleveurs = res.data.filter((u: { roles: any; }) => {
            const roles = Array.isArray(u.roles) ? u.roles : [u.roles];
            return roles.includes('ROLE_PRELEVEUR');
          });
        }
      },
      error: err => console.error('❌ Erreur préleveurs :', err)
    });
  }

  // --- Produits ---
  loadProducts() {
    this.sampleService.getAllProducts().subscribe(data => this.productList = data);
  }

  toggleForm() {
    this.showForm = !this.showForm;
  }
// تحويل Date (JS) → YYYY-MM-DD
private formatDateOnly(date: Date | null | undefined): string | undefined {
  if (!date) return undefined;

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');

  return `${y}-${m}-${d}`;
}

updatePrelevement() {
  console.log('🟩 updatePrelevement() appelé');

  if (!this.form.valid) {
    console.warn('⚠️ Formulaire invalide');
    console.log('💡 form.value:', this.form.value);
    console.log('💡 form.rawValue:', this.form.getRawValue());
    return;
  }

  console.log("📌 form.value AVANT:", this.form.value);
  console.log("📌 form.rawValue AVANT:", this.form.getRawValue());

  const dto: PrelevementSampleDto = {
    typeSampleName: this.form.value.typeSampleName,
    clientId: this.form.value.clientId,
    terrainId: this.form.value.terrainId,
    batchReference: this.form.value.batchReference,
    accredited: this.form.value.accredited,
    preleveParClient: this.form.value.preleveParClient,
    batchId: this.form.value.batchId,
    collectionDate: this.form.value.collectionDate || undefined,
    collectedById: this.form.value.collectedById,
    qtePre: this.form.value.qtePre,
    temperaturePrelevement: this.form.value.temperaturePrelevement,
    typeAnalyseId: this.form.value.typeAnalyseId ?? null,
    matriceId: this.form.value.matriceId ?? null,
    designation: this.form.value.designation || '',
    scelle: this.form.value.scelle || false,
    departmentIds: this.form.value.departmentIds || '',
    conditionnement: this.form.value.conditionnement || '',
    priorite: this.form.value.priorite || '',
    dateProduction: this.formatDateOnly(this.form.value.dateProduction),
    dateLimiteConsommation: this.formatDateOnly(this.form.value.dateLimiteConsommation)
  };

  console.log('📦 DTO pour update:', dto);

  // ✅ FIX ID
  const sampleId = this.form.getRawValue().id;

  console.log("🆔 sampleId (rawValue.id) =", sampleId);

  if (!sampleId) {
    console.error("❌ sampleId est undefined/null -> le PUT ne peut pas marcher !");
    console.log("📌 form.value.id =", this.form.value.id);
    console.log("📌 form.rawValue.id =", this.form.getRawValue().id);
    return;
  }

  this.sampleService.updatePrelevement(sampleId, dto).subscribe({
    next: res => {
      console.log('✅ Prélèvement mis à jour avec succès', res);
      this.modalService.dismissAll();
      this.cdr.detectChanges();
      this.dialogService.openSuceessAlert('Échantillon modifié avec succès');
      this.loadPrelevements();
    },
    error: err => {
      console.error('❌ Erreur lors de la mise à jour', err);
      console.log("💡 err.error =", err.error);
    }
  });
}


    onLotChange(batchId: number | null) {
    if (batchId) {
      const selectedLot = this.lotList.find(l => l.id === batchId);
      if (selectedLot) {
        this.selectedLotId = selectedLot.id;
        this.selectedClientId = selectedLot.clientId;
        this.form.patchValue({
          batchId: selectedLot.id,
          clientId: selectedLot.clientId
        });
        this.form.get('batchId')?.disable();
        this.form.get('clientId')?.disable();
        this.fetchTerrainList(this.selectedClientId);
      }
    } else {
      this.selectedLotId = null;
      this.selectedClientId = null;
      this.form.get('batchId')?.enable();
      this.form.get('clientId')?.enable();
    }
  }

  // --- Sélection d'un produit ---
  onProductSelected(product: ProductData) {
    this.form.get('typeSample')?.setValue(product.id);
    this.sampleTypeControl.setValue(product.productName, { emitEvent: false });
  }


  private toDatetimeLocal(value: string | null | undefined): string | null {
    if (!value) return null;

    // "2025-02-20T23:00:00" → "2025-02-20T23:00"
    return value.substring(0, 16);
  }

removeTableRow(sampleAnalyseId: number) {
  this.dataSource.data = this.dataSource.data.filter(
    (sample: SampleAnalyseResponseDto) => sample.sampleAnalyseId !== sampleAnalyseId
  );
  this.dataSource = new MatTableDataSource<SampleAnalyseResponseDto>(this.dataSource.data);
}

// --- Soumission du formulaire ---
  submit() {
    if (!this.form.valid) {
      console.warn('⚠️ Formulaire invalide, vérifier les champs requis');
      return;
    }

    console.log('✅ Formulaire valide, préparation du DTO...');

    // ⭐ الحل 1: استرجاع القيم بما فيها الحقول المعطّلة
    const rawValue = this.form.getRawValue();

    const dto: PrelevementSampleDto = {
      typeSampleName: rawValue.typeSampleName,
      clientId: rawValue.clientId,
      batchId: rawValue.batchId,
      batchReference: rawValue.batchReference,
      accredited: rawValue.accredited,
      preleveParClient: rawValue.preleveParClient,
      terrainId: rawValue.terrainId,
      collectionDate: rawValue.collectionDate || undefined,
      collectedById: rawValue.collectedById,
      qtePre: rawValue.qtePre,
      temperaturePrelevement: rawValue.temperaturePrelevement,
      dateProduction: rawValue.dateProduction,
      dateLimiteConsommation: rawValue.dateLimiteConsommation,
      typeAnalyseId: rawValue.typeAnalyseId ?? null,
      matriceId: rawValue.matriceId ?? null,
      designation: rawValue.designation || '',
      departmentIds: rawValue.departmentIds || '',
      scelle: rawValue.scelle || false,
      conditionnement: rawValue.conditionnement || '',
      priorite: rawValue.priorite || ''
    };

    console.log('📦 DTO prêt à être envoyé :', dto);

    this.sampleService.createPrelevement(dto).subscribe({
      next: res => {
        this.modalService.dismissAll();
        this.cdr.detectChanges();

        if (res) {
          this.dialogService.openSuceessAlert('Échantillon créé avec succès');
          this.loadPrelevements();
        } else {
          this.dialogService.open(
            res.message || 'Erreur lors de la création du prélèvement.',
            environment.error_message_type,
            'danger',
            environment.error_icon
          );
        }
      },
      error: err => {
        console.error('❌ Erreur lors de la création du prélèvement :', err);
        if (err.error) console.error('💡 Détails de l’erreur:', err.error);

        this.dialogService.open(
          err.error?.message || 'Erreur lors de la création du prélèvement.',
          environment.error_message_type,
          'danger',
          environment.error_icon
        );
      }
    });
  }

  // --- Supprimer un prélèvement ---
  deleteSample(id: number) {
    this.apiService.delete(id, this.endpoints.sampler_base_endpoint + '/delete_sample').pipe(
        tap((response: any) => {
            console.log('Réponse de suppression :', response); // ✅ Console ajoutée

            if (response.status) {
                this.removeTableRow(id);
                this.dialogService.openSuceessAlert('Échantillon supprimé avec succès');
            } else {
                this.dialogService.openDangerAlert(response.message || 'Suppression échouée');
            }
        }),
        finalize(() => {
            this.dataSource.paginator = this.paginator;
        })
    ).subscribe({
        error: (err) => {
            console.error('Erreur lors de la suppression :', err); // ✅ Console ajoutée
            this.dialogService.openDangerAlert(err.error.message || 'Erreur serveur');
        }
    });
}

  openViewSample(sample: any) {  
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.clearValidators();
      this.form.get(key)?.updateValueAndValidity({ emitEvent: false });
    });
  
    this.form.patchValue({
      id: sample.id || '',
      sampleCode: sample.sampleCode || '',
      typeSampleName: sample.typeSampleName || '',
      clientName: sample.clientName || '',
      batchReference: sample.batchReference || '',
      accredited: sample.accredited || '',
      preleveParClient: sample.preleveParClient || '',
      terrainVarPlante: sample.terrainVarPlante || '',
      collectedByUsername: sample.collectedByUsername || '',
  
      qtePre: sample.qtePre || '',
      collectionDate: sample.collectionDate ? new Date(sample.collectionDate) : '',
      matriceId: sample.matriceId || null,
      typeAnalyseId: sample.typeAnalyseId || null,
      designation: sample.designation || '',
      departmentIds: sample.departmentIds || '',
      scelle: sample.scelle != null ? sample.scelle : null,
      conditionnement: sample.conditionnement || '',
      priorite: sample.priorite || '',
      temperaturePrelevement: sample.temperaturePrelevement || '',
      dateProduction: sample.dateProduction ? new Date(sample.dateProduction) : '',
      dateLimiteConsommation: sample.dateLimiteConsommation ? new Date(sample.dateLimiteConsommation) : ''
    });
  
    console.log("📝 Etat du form APRÈS :", this.form.value);
  
    this.modalService.open(this.viewModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl'
    });
  
    console.log("====== ✅ MODAL OUVERT ======");
  }
  
editSample(sample: any) {
  console.log("🟦 editSample() appelé");
  console.log("📌 sample reçu:", sample);
  console.log("🆔 sample.id =", sample?.id);

  // 🔹 Vérifier si le form contient bien le champ id
  console.log("🔍 form has control 'id' ?", !!this.form.get('id'));
  console.log("🔍 control id =", this.form.get('id'));

  forkJoin({
    matrices: this.matriceService.fetchMatriceList(),
    typeAnalyses: this.typeAnalyseService.getAllTypeAnalyse()
  }).subscribe({
    next: ({ matrices, typeAnalyses }) => {

      this.matriceList = matrices.data as ShortMatriceDto[];
      this.typeAnalyseList = typeAnalyses;

      console.log("✅ matrices chargées:", this.matriceList.length);
      console.log("✅ typeAnalyses chargées:", this.typeAnalyseList.length);

      // 🔥 IMPORTANT : forcer l'id dans le form même si patchValue échoue
      if (this.form.get('id')) {
        this.form.get('id')?.setValue(sample.sampleAnalyseId);
        console.log("✅ id setValue() =", this.form.get('id')?.value);
      } else {
        console.error("❌ Le FormGroup n'a pas de champ 'id' !! Ajoute-le dans formBuilder.");
      }

      // PatchValue pour remplir le formulaire
      this.form.patchValue({
        id: sample.sampleAnalyseId,
        sampleCode: sample.sampleCode || '',
        typeSampleName: sample.typeSampleName || '',
        clientId: sample.clientId || null,
        batchReference: sample.batchReference || null,
        accredited: sample.accredited != null ? sample.accredited : null,
        preleveParClient: sample.preleveParClient != null ? sample.preleveParClient : null,
        terrainId: sample.terrainId || null,
        collectedById: sample.collectedById || null,
        matriceId: sample.matriceId || null,
        typeAnalyseId: sample.typeAnalyseId || null,
        clientName: sample.clientName || '',
        batchName: sample.batchName || '',
        terrainVarPlante: sample.terrainVarPlante || '',
        collectedByUsername: sample.collectedByUsername || '',
        qtePre: sample.qtePre || '',
        collectionDate: this.toDatetimeLocal(sample.collectionDate),
        temperaturePrelevement: sample.temperaturePrelevement || '',
        dateProduction: sample.dateProduction ? new Date(sample.dateProduction) : null,
        dateLimiteConsommation: sample.dateLimiteConsommation ? new Date(sample.dateLimiteConsommation) : null,
        designation: sample.designation || '',
        departmentIds: sample.departmentIds || '',
        scelle: sample.scelle != null ? sample.scelle : null,
        conditionnement: sample.conditionnement || '',
        priorite: sample.priorite || ''
      });

      console.log("📦 Form value après patchValue():", this.form.value);
      console.log("📦 Form rawValue après patchValue():", this.form.getRawValue());
      console.log("🆔 form.value.id =", this.form.value.id);
      console.log("🆔 form.getRawValue().id =", this.form.getRawValue().id);

      // 🔹 Ouvrir le modal après que le formulaire est patché
      this.modalService.open(this.editModal, { size: 'lg' });
    },
    error: (err) => {
      console.error("❌ Erreur lors de la récupération des matrices/typeAnalyses", err);
    }
  });
}

getSampleCountForBatch(batchId: number): number {
    console.log('🔍 [getSampleCountForBatch] batchId reçu =', batchId);

    console.log('📦 [getSampleCountForBatch] Tous les samples:', this.dataSource.data);

    const filteredSamples = this.dataSource1.data.filter(sample => {
        const match = sample.batchId === batchId;
      
        return match;
    });

    console.log(
        `✅ [getSampleCountForBatch] Nombre de samples pour batch ${batchId} =`,
        filteredSamples.length
    );

    return filteredSamples.length;
}
getRemainingSamples(batchId?: number): number {
  const id = batchId ?? this.selectedLotId;
  if (!id) return 0;

  const selectedLot = this.lotList?.find(lot => lot.id === id);
  if (!selectedLot) return 0;

  const currentSampleCount = this.dataSource1.data.filter(s => s.batchId === id).length;
  const maxSamplesAllowed = selectedLot.numberOfSamples || 0;

  console.log('📊 Lot ID:', id, 'Actuel:', currentSampleCount, 'Max:', maxSamplesAllowed);

  return maxSamplesAllowed - currentSampleCount;
}


confirmDelete(element: any) {
  this.dialogService.open('Vous etes sur de supprimer cet échantillon?', environment.warning_message_type, 'danger', environment.warning_icon, true)
      .then((result: any) => {
          if (result) {
              this.deleteSample(element.id);
          }
      });
}
user_name = sessionStorage.getItem('user_name');

private setColsCookie() {
  this.cookieService.set(`prelCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
      expires: 7,
      path: '/',
      secure: true
  });
}
private getColsCookie() {
  const sampleCols = this.cookieService.get(`prelCol_${this.user_name}`); // Get the cookie value

  if (sampleCols) {
      this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
      console.log('Retrieved object:', sampleCols);


}
}

handleIsAllColsSelected(event: MatCheckboxChange) {
  if (event.checked) {
      this.displayedColumns = [...this.columns]
  } else {
      this.displayedColumns = []
  }
  this.setColsCookie()
}

getdisplayedCol = (): string[] => {
  return ['select', ...this.displayedColumns, 'action']
};

ngAfterViewInit() {
  this.initializePaginatorAndSort()
}

initializePaginatorAndSort() {
  this.overlayContainer.getContainerElement().style.zIndex = '2000';
  this.dataSource.filter = this.searchVal
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
  this.sort.active = 'id';
  this.sort.direction = 'desc';

}
}


